import React from 'react';
import Placeholder from '~/components/Dynamic/Placeholder';
import Hero from '~/components/Dynamic/Hero';
import Grid from '~/components/Dynamic/Grid';
import TwoColTextImage from '~/components/Dynamic/TwoColTextImage';
import TwoColumns from '~/components/Dynamic/TwoColumns';
import TextCard from '~/components/Dynamic/TextCard';
import Button from '~/components/Dynamic/Button';
import Image from '~/components/Dynamic/Image';
import ImageGrid from '~/components/Dynamic/ImageGrid';
import LogoStrip from '~/components/Dynamic/LogoStrip';
import FaqSection from '~/components/Dynamic/FaqSection';
import TwoColCustomerSlider from '~/components/Dynamic/TwoColCustomerSlider';
import HomepageFeatures from '~/components/Dynamic/HomepageFeatures';
import FeaturedCustomerSection from '~/components/Dynamic/FeaturedCustomerSection';
import CustomersTestimonialSection from '~/components/Dynamic/CustomersTestimonialSection';
import Grid1 from '~/components/Dynamic/Grid1';
import FeatureGrid from '~/components/Dynamic/FeatureGrid';
import InlineIconTextCards from '~/components/Dynamic/InlineIconTextCards';
import InlineIconTextCardsSection from '~/components/Dynamic/InlineIconTextCardsSection';
import SimpleTestimonialSection from '~/components/Dynamic/SimpleTestimonialSection';
import VisualContentSlider from '~/components/Dynamic/VisualContentSlider';
import Slider from '~/components/Dynamic/Slider';
import TwoColumnIconCards from '~/components/Dynamic/TwoColumnIconCards';
import TwoColCountupStats from '~/components/Dynamic/TwoColCountupStats';
import TextCardAndGrid from '~/components/Dynamic/TextCardAndGrid';
import LatestBlogPosts from '~/components/Dynamic/LatestBlogPosts';
import Grid2 from '~/components/Dynamic/Grid2';
import Video from '~/components/Dynamic/Video';
import Steps from '~/components/Dynamic/Steps';
import TwoColTextSlider from '~/components/UseCaseSlider'; // TODO: move this to /Dynamic folder once component is done

const Components = {
  hero: Hero,
  grid: Grid,
  textCard: TextCard,
  button: Button,
  image: Image,
  'Two Column Text Image': TwoColTextImage,
  'twoColTextSlider': TwoColTextSlider,
  twoColumns: TwoColumns,
  'Image Grid': ImageGrid,
  'Logo Strip': LogoStrip,
  faqSection: FaqSection,
  twoColCustomerSlider: TwoColCustomerSlider,
  homepageFeatures: HomepageFeatures,
  customersTestimonialSection: CustomersTestimonialSection,
  grid1: Grid1,
  featureGrid: FeatureGrid,
  inlineIconTextCards: InlineIconTextCards,
  inlineIconTextCardsSection: InlineIconTextCardsSection,
  visualContentSlider: VisualContentSlider,
  imageSlider: Slider,
  simpleTestimonialSection: SimpleTestimonialSection,
  twoColumnIconCards: TwoColumnIconCards,
  twoColCountupStats: TwoColCountupStats,
  featuredCustomer: FeaturedCustomerSection,
  textCardAndGrid: TextCardAndGrid,
  latestBlogPosts: LatestBlogPosts,
  grid2: Grid2,
  video: Video,
  steps: Steps,
};

const Component = ({ blok }) => {
  if (!blok || !blok.component) return null;
  if (typeof Components[blok.component] !== 'undefined') {
    const Component = Components[blok.component];
    return <Component blok={blok} />;
  }

  return blok?.component ? <Placeholder componentName={blok.component} /> : null;
};

export default Component;
